import { StringKey } from '../../../../../../../lang/index';

export enum SarColumn {
  BASE_PRICE = 'base-price',
  EXERCISE_DATE = 'exercise-date',
  GRANT = 'grant',
  ISSUED_SHARES = 'issued-shares',
  NO_OF_SARS = 'no-of-sars',
  REMOVE_ROW = 'remove-row',
  SAR_FOR_EXERCISING = 'sar-for-exercising',
  SAR_PAYOUT = 'sar-payout',
  SHARE_PRICE = 'share-price',
  STAKEHOLDER = 'stakeholder',
}
export const sarColumnMap = Object.values(SarColumn);

export const sarColumnTitle: Record<SarColumn, StringKey> = {
  [SarColumn.STAKEHOLDER]: 'STAKEHOLDER',
  [SarColumn.GRANT]: 'GRANT',
  [SarColumn.EXERCISE_DATE]: 'EXERCISE_DATE',
  [SarColumn.SAR_FOR_EXERCISING]: 'SAR_FOR_EXERCISING',
  [SarColumn.BASE_PRICE]: 'BASE_PRICE',
  [SarColumn.SHARE_PRICE]: 'SHARES_PRICE',
  [SarColumn.NO_OF_SARS]: 'NO_OF_SARS',
  [SarColumn.SAR_PAYOUT]: 'SAR_PAYOUT',
  [SarColumn.ISSUED_SHARES]: 'ISSUED_SHARES',
  [SarColumn.REMOVE_ROW]: 'EMPTY',
};
